import { render } from "./residueSection.vue?vue&type=template&id=3953f7fc&scoped=true"
import script from "./residueSection.vue?vue&type=script&lang=js"
export * from "./residueSection.vue?vue&type=script&lang=js"

import "./residueSection.vue?vue&type=style&index=0&id=3953f7fc&scoped=true&lang=css"

import exportComponent from "/data/PDBcov/VueJs/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3953f7fc"]])

export default __exports__